/* MISSION | BF26 Shop the Sale */
(function () {
  if (window.__bfsInit) return; window.__bfsInit = true;
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var p2 = function (n) { return (n < 10 ? '0' : '') + n; };

  /* countdowns: any element with data-bfs-end holds [data-u=d|h|m|s] */
  var cds = $$('[data-bfs-end]').map(function (el) {
    return { el: el, end: new Date(el.getAttribute('data-bfs-end')).getTime() };
  });
  function tick() {
    var now = Date.now();
    cds.forEach(function (c) {
      var ms = isNaN(c.end) ? 0 : Math.max(0, c.end - now);
      var v = { d: Math.floor(ms / 864e5), h: Math.floor(ms / 36e5) % 24, m: Math.floor(ms / 6e4) % 60, s: Math.floor(ms / 1e3) % 60 };
      $$('[data-u]', c.el).forEach(function (b) { b.textContent = p2(v[b.getAttribute('data-u')]); });
    });
  }
  if (cds.length) { tick(); setInterval(tick, 1000); }

  /* buy-2 strip: mobile scroll indicator */
  $$('.b2M-in').forEach(function (box) {
    var ls = box.querySelector('.b2M-ls'), th = box.querySelector('.b2M-sb i');
    if (!ls || !th) return;
    var upd = function () { if (!ls.scrollWidth) return; th.style.width = (ls.clientWidth / ls.scrollWidth * 100) + '%'; th.style.left = (ls.scrollLeft / ls.scrollWidth * 100) + '%'; };
    ls.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd();
  });

  /* gift carousel arrows */
  $$('.gcar').forEach(function (car) {
    var tr = car.querySelector('.gtrack');
    $$('[data-gs]', car).forEach(function (b) {
      b.addEventListener('click', function () { tr.scrollBy({ left: +b.getAttribute('data-gs') * tr.clientWidth * 0.8, behavior: 'smooth' }); });
    });
  });

  /* jump bar: built from every section that has data-bfs-nav, in page order */
  var bar = document.querySelector('.bfs-snav');
  if (!bar) return;
  var inner = bar.querySelector('.snin');
  var targets = $$('[data-bfs-nav]').filter(function (el) { return el.getAttribute('data-bfs-nav'); });
  if (!targets.length) { bar.hidden = true; return; }
  document.body.classList.add('bfs-has-snav');
  inner.innerHTML = targets.map(function (el, i) {
    return '<button type="button" class="si" data-i="' + i + '"><span>' + el.getAttribute('data-bfs-nav').replace(/</g, '&lt;') + '</span></button>';
  }).join('');
  var btns = $$('.si', inner);
  btns.forEach(function (b) {
    b.addEventListener('click', function () {
      var t = targets[+b.getAttribute('data-i')];
      t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
  var hero = document.querySelector('.bfband') || targets[0];
  var active = -1;
  function onScroll() {
    var hb = hero.getBoundingClientRect().bottom;
    bar.classList.toggle('on', hb < 0);
    document.body.classList.toggle('bfs-snav-on', hb < 0);
    var line = innerHeight * 0.35, idx = 0;
    targets.forEach(function (t, i) { if (t.getBoundingClientRect().top < line) idx = i; });
    if (idx !== active) {
      active = idx;
      btns.forEach(function (b, i) { b.classList.toggle('on', i === idx); });
      var a = btns[idx];
      if (a && inner.scrollWidth > inner.clientWidth) inner.scrollTo({ left: a.offsetLeft - inner.clientWidth / 2 + a.offsetWidth / 2, behavior: 'smooth' });
    }
  }
  addEventListener('scroll', onScroll, { passive: true }); onScroll();
})();
